import actions from './actions';
import reducers from './reducers';
import selectors from './selectors';
import verifiers from './verifiers';

export default {
  actions,
  reducers,
  selectors,
  verifiers,
};
